export const BREAKPOINTS_LABELS = ['xs', 'xs', 'sm', 'md', 'lg', 'xl'];

export const BREAKPOINTS_IN_PIXELS = {
  minWidth: {
    xs: '(min-width: 480px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 1280px)',
    xl: '(min-width: 1920px)',
  },
  maxWidth: {
    xs: '(max-width: 480px)',
    sm: '(max-width: 576px)',
    md: '(max-width: 768px)',
    lg: '(max-width: 1279px)',
    xl: '(max-width: 1920px)',
  }
} as const;

export const DEVICE_TYPE = {
  MOBILE: 1,
  TABLET: 2,
  DESKTOP: 3
} as const;

export const RESOLUTION = {
  full: 1000,
  medium: 531,
  thumb: 280,
  mobile: 150
} as const;

export const DEFAULT_RESOLUTION = 'medium';

export const FULL_SCREEN_CONTAINER_MOBILE = {
  MENU: 'Menu',
  FILTER: 'Filter',
  SORT: 'Sort',
  ORDER_FILTERS: 'OrderFilters'
} as const;

export const SCREEN_SIZE_UPDATE_DELAY = 1000;

export const ACT_AS_BACKGROUND_COLOR = '#e39500'; // $orange20
